
import React from 'react';

export const VpnSection: React.FC = () => {
  return (
    <section id="vpn" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
          <div>
            <div className="space-y-4 mb-8">
              <h3 className="text-4xl text-gray-500 font-normal">Our VPN</h3>
              <h2 className="text-5xl text-gray-900 font-bold italic">Technology</h2>
            </div>
          </div>
          
          <div>
            <p className="text-lg text-gray-600 leading-relaxed">
              Experience the next generation of VPN technology with our advanced security protocols, 
              lightning-fast connections, and global server network designed to protect your digital identity.
            </p>
          </div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-purple-50 p-8 rounded-xl">
            <div className="mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/5dd10ea341cdac6406f40b685d6fbf1f.jpg"
                alt="Military-Grade Encryption"
                className="w-full h-40 object-cover rounded-lg"
              />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-4">Military-Grade Encryption</h4>
            <p className="text-gray-600 leading-relaxed">
              256-bit AES encryption ensures your data remains completely secure and unreadable to unauthorized parties.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="text-center space-y-6">
              <h4 className="text-xl font-bold text-gray-900">No-Log Policy</h4>
              <div className="flex justify-center">
                <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-white text-3xl"></i>
                </div>
              </div>
              <p className="text-gray-600">
                We don't track, collect, or store any of your online activities. Your privacy is guaranteed.
              </p>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="text-center space-y-6">
              <h4 className="text-xl font-bold text-gray-900">Global Servers</h4>
              <div className="flex justify-center">
                <img 
                  src="https://readdy.ai/api/search-image?query=world%20map%20with%20connection%20nodes%2C%20global%20server%20network%20illustration%2C%20purple%20connection%20lines%2C%20minimal%20tech%20design%2C%20data%20centers%20worldwide%20visualization&width=200&height=120&seq=servers1&orientation=landscape"
                  alt="Global Server Network"
                  className="w-full h-24 object-cover rounded-lg"
                />
              </div>
              <p className="text-gray-600">
                Connect to our worldwide server network for optimal speed and unrestricted access.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
